import Swiper from 'swiper';
import { Thumbs, EffectFade } from 'swiper/modules';


class ListingZoneLivraison {
  private swiperContainer: HTMLElement | null;
  private swiperNavContainer: HTMLElement | null;
  private swiperNavInstance: Swiper | null = null;
  private swiperMainInstance: Swiper | null = null;
  private readonly breakpoint = 1025;

  constructor() {
    this.swiperContainer = document.querySelector('.listing-zone-livraison__swiper');
    this.swiperNavContainer = document.querySelector('.listing-zone-livraison__swiper-nav');

    if (!this.swiperContainer || !this.swiperNavContainer) {
      return;
    }
    this.checkAndInitSwipers();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  private initSwipers(): void {
    if (this.swiperNavContainer && !this.swiperNavInstance) {
      this.swiperNavInstance = new Swiper(this.swiperNavContainer, {
        spaceBetween: 24,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
      });
    }

    if (this.swiperContainer && !this.swiperMainInstance && this.swiperNavInstance) {
      this.swiperMainInstance = new Swiper(this.swiperContainer, {
        modules: [Thumbs, EffectFade],
        effect: "fade",
        spaceBetween: 0,
        thumbs: {
          swiper: this.swiperNavInstance,
        },
      });
    }
  }

  /**
   * Détruit les instances Swiper si elles existent.
   */
  private destroySwipers(): void {
    if (this.swiperMainInstance) {
      this.swiperMainInstance.destroy(true, true);
      this.swiperMainInstance = null;
    }
    if (this.swiperNavInstance) {
      this.swiperNavInstance.destroy(true, true);
      this.swiperNavInstance = null;
    }
  }

  private checkAndInitSwipers(): void {
    const isMobile = window.innerWidth <= this.breakpoint;
    const isInitialized = this.swiperMainInstance !== null;

    if (isMobile && !isInitialized) {
      this.initSwipers();
    } else if (!isMobile && isInitialized) {
      this.destroySwipers();
    }
  }

  private handleResize(): void {
    this.checkAndInitSwipers();
  }

}

document.addEventListener('DOMContentLoaded', () => {
  new ListingZoneLivraison();
});